/* =============== Helpers =============== */
function showLoader() {
  const loader = document.getElementById('cart-loader');
  if (loader) loader.style.display = 'flex';
}

function hideLoader() {
  const loader = document.getElementById('cart-loader');
  if (loader) loader.style.display = 'none';
}

/* =============== Weight-Loss Collection Guard (cache + lookup) =============== */
const WL_COLLECTION_HANDLE = 'weight-loss-products';
let WL_PRODUCT_IDS = new Set();
let WL_LOADING = null;

// Load all product IDs from /collections/weight-loss-products/
async function ensureWeightLossIdsLoaded() {
  if (WL_PRODUCT_IDS.size > 0) return;
  if (WL_LOADING) { await WL_LOADING; return; }

  WL_LOADING = (async () => {
    let page = 1, got = 0;
    try {
      do {
        const res = await fetch(`/collections/${WL_COLLECTION_HANDLE}/products.json?limit=250&page=${page}`, {
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) break;
        const data = await res.json();
        const items = Array.isArray(data?.products) ? data.products : [];
        got = items.length;
        items.forEach(p => { if (p?.id) WL_PRODUCT_IDS.add(Number(p.id)); });
        page++;
      } while (got > 0);
    } catch (e) {
      console.warn('Could not load WL collection products; fallback checks disabled.', e);
    }
  })();

  await WL_LOADING; WL_LOADING = null;
}

function isWeightLossProductId(productId) {
  return WL_PRODUCT_IDS.has(Number(productId));
}

// Lines in drawer that must stay at qty=1
window.restrictedLines = new Set();

/* =============== Drawer Open/Close =============== */
async function openCartDrawer(cartData, shouldAnimate = true) {
  const drawer = document.getElementById('lift-cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  const header = document.querySelector('.cart-drawer__header');
  const footer = document.querySelector('.cart-drawer__footer');
  const itemsContainer = document.getElementById('lift-cart-drawer-items');
  const subtotalElement = document.getElementById('lift-cart-drawer-subtotal');

  if (!drawer || !overlay || !itemsContainer || !subtotalElement) {
    console.error('Cart drawer elements missing.');
    return;
  }

  // Make sure WL IDs are loaded, and auto-fix any WL lines with qty != 1
  await ensureWeightLossIdsLoaded();
  if (cartData?.items?.length) {
    const fixes = [];
    cartData.items.forEach((it, i) => {
      if (isWeightLossProductId(it.product_id) && it.quantity !== 1) {
        fixes.push(i + 1); // 1-based
      }
    });
    if (fixes.length) {
      await Promise.all(
        fixes.map(line =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 1 })
          })
        )
      );
      cartData = await fetch('/cart.js').then(r => r.json());
    }
  }

  itemsContainer.innerHTML = '';
  window.restrictedLines.clear();

  // detect currency
  const currencyCode =
    (cartData && cartData.currency) ||
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    'GBP';

  const money = new Intl.NumberFormat('en', { style: 'currency', currency: currencyCode });

  if (!cartData || !cartData.items || cartData.items.length === 0) {
    if (header) header.style.display = 'none';
    if (footer) footer.style.display = 'none';
    itemsContainer.innerHTML = `
      <tr>
        <td colspan="4" style="text-align:center; padding: 40px 20px; border-bottom: none !important;">
          <img src="https://cdn.shopify.com/s/files/1/0806/7150/6765/files/delete_1.png?v=1753769685"
               alt="Empty Cart" style="width: 170px; opacity: 0.6; margin-bottom: 20px;">
          <div style="font-size: 32px; font-weight: 700; margin-bottom: 20px; color: #242E54;">Your cart is empty</div>
          <div style="font-size: 16px; color: #242E54;">Add products to your cart.</div>
          <br>
          <button onclick="closeCartDrawer()" class="btn-custom bundle-cta-button btn hover-filled-slide-up btn-1 cart_close_btn">
            <span>Close</span>
          </button>
        </td>
      </tr>`;
    subtotalElement.textContent = money.format(0);
  } else {
    if (header) header.style.display = '';
    if (footer) footer.style.display = '';

    let html = '';
    let customTotal = 0;

    cartData.items.forEach((item, index) => {
      // "Custom Price" from line item properties (string like "49.99" or "£49.99")
      const rawCustom = item.properties?.['Custom Price'];
      const parsedCustom = rawCustom ? parseFloat(String(rawCustom).replace(/[^\d.]/g, '')) : null;

      // default to Shopify per-unit price if no custom price
      const unitPrice = parsedCustom ?? (item.final_line_price / item.quantity / 100);
      const lineTotal = unitPrice * item.quantity;
      customTotal += lineTotal;

      const productImage = item.image
        ? `<img src="${item.image}" alt="${item.title}" style="object-fit: cover; width: 78px; height: 80px; border-radius: 8px;">`
        : '';

      // Detect WL product -> restrict qty controls and display 1
      const isWL = isWeightLossProductId(item.product_id);
      if (isWL) window.restrictedLines.add(index + 1);

      const qtyControls =
        `<div class="quantity-control ${isWL ? 'is-restricted' : ''}" data-index="${index + 1}">
            <button class="quantity-btn" ${isWL ? 'disabled aria-disabled="true"' : ''} onclick="updateQuantity(${index + 1}, -1)">−</button>
            <span class="quantity-number">${isWL ? 1 : item.quantity}</span>
            <button class="quantity-btn" ${isWL ? 'disabled aria-disabled="true"' : ''} onclick="updateQuantity(${index + 1}, 1)">+</button>
         </div>`;

      html += `
        <tr class="product_item_tr">
          <td style="padding:10px;" class="1st_td_cart">
            <div class="cart-product-info">
              ${productImage}
              <div>
                <div class="cart-product-title">${item.product_title}</div>
                <div class="cart-product-price-text">${money.format(unitPrice)}</div>

                <div class="quantity-control quantity_mobile ${isWL ? 'is-restricted' : ''}" data-index="${index + 1}">
                  <button class="quantity-btn" ${isWL ? 'disabled aria-disabled="true"' : ''} onclick="updateQuantity(${index + 1}, -1)">−</button>
                  <span class="quantity-number">${isWL ? 1 : item.quantity}</span>
                  <button class="quantity-btn" ${isWL ? 'disabled aria-disabled="true"' : ''} onclick="updateQuantity(${index + 1}, 1)">+</button>
                </div>
              </div>
            </div>
          </td>
          <td style="text-align:center;" class="quantity_td">
            ${qtyControls}
          </td>
          <td style="text-align:center;">
            <button onclick="removeCartItem('${item.key}')" class="cart-remove">Remove</button>
          </td>
        </tr>`;
    });

    itemsContainer.innerHTML = html;
    subtotalElement.textContent = money.format(customTotal);
  }

  drawer.classList.remove('hidden');
  overlay.classList.remove('hidden');

  // Animate if GSAP exists, else just show
  if (shouldAnimate && window.gsap) {
    gsap.fromTo(
      drawer,
      { x: '100%', opacity: 0 },
      { x: '0%', opacity: 1, duration: 0.5, ease: 'power3.out' }
    );
    gsap.fromTo(
      overlay,
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: 'power3.out' }
    );
  } else {
    drawer.style.transform = 'translateX(0)';
    drawer.style.opacity = 1;
    overlay.style.opacity = 1;
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('lift-cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  if (!drawer || !overlay) return;

  if (window.gsap) {
    gsap.to(drawer, {
      x: '100%',
      opacity: 0,
      duration: 0.5,
      ease: 'power2.in',
      onComplete: () => drawer.classList.add('hidden')
    });

    gsap.to(overlay, {
      opacity: 0,
      duration: 0.5,
      onComplete: () => overlay.classList.add('hidden')
    });
  } else {
    drawer.classList.add('hidden');
    overlay.classList.add('hidden');
  }
}

/* =============== Cart API Actions =============== */
function addToCartAndOpenDrawer(variantId, quantity = 1, properties = {}, sellingPlanId = null) {
  if (!variantId) {
    alert('Invalid variant selected.');
    return;
  }

  showLoader();

  // 🧾 Debug log
  console.log('🛒 Add to cart request:', {
    variantId,
    quantity,
    properties,
    sellingPlanId
  });

  // Build the item object
  const item = {
    id: variantId,
    quantity,
    properties
  };

  // ✅ Only include selling_plan if it's provided
  if (sellingPlanId) {
    item.selling_plan = sellingPlanId;
  }

  const payload = { items: [item] };

  // 🛒 POST to Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(res => {
      if (!res.ok) {
        return res.json().then(err => Promise.reject(err));
      }
      return res.json();
    })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      hideLoader();
      // openCartDrawer is async; we can call without await
      openCartDrawer(cart, true);
    })
    .catch(err => {
      hideLoader();
      const errorMessage = err?.description || 'Failed to add to cart.';
      alert(errorMessage);
      console.error('Add to cart error:', err);
    });
}

async function checkStockAndAdd(variantId, quantity = 1, properties = {}) {
  showLoader();
  try {
    const variantRes = await fetch(`/variants/${variantId}.js`);
    if (!variantRes.ok) throw new Error('Invalid variant.');
    const variant = await variantRes.json();

    if (!variant?.available) {
      hideLoader();
      alert('This product is sold out.');
      return;
    }

    // Enforce WL qty=1 at add-time if product belongs to WL collection
    await ensureWeightLossIdsLoaded();
    if (isWeightLossProductId(variant.product_id) && quantity !== 1) {
      quantity = 1;
      // Optional: alert('This product is limited to 1 per order.');
    }

    addToCartAndOpenDrawer(variantId, quantity, properties);
  } catch (err) {
    hideLoader();
    alert('Error checking product stock.');
    console.error(err);
  }
}

function updateCartQuantity(line, quantity) {
  // If this line is WL restricted, always force 1
  if (window.restrictedLines.has(Number(line))) {
    quantity = 1;
  }

  showLoader();
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity: parseInt(quantity, 10) })
  })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      hideLoader();
      openCartDrawer(cart, false);
    })
    .catch(err => {
      hideLoader();
      console.error('Failed to update quantity', err);
    });
}

function removeCartItem(lineItemKey) {
  showLoader();
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      hideLoader();
      openCartDrawer(cart, false);
    })
    .catch(err => {
      hideLoader();
      console.error('Failed to remove item', err);
    });
}

/* =============== Quantity +/- (line-indexed) =============== */
function updateQuantity(line, delta) {
  const node = document.querySelector(`.quantity-control[data-index="${line}"] .quantity-number`);
  const current = parseInt(node?.textContent || '1', 10);
  let next = Math.max(0, current + delta);

  // WL lines always 1
  if (window.restrictedLines.has(Number(line))) {
    next = 1;
  }
  if (next === current) return;
  updateCartQuantity(line, next);
}

/* =============== DOM Listeners =============== */
document.addEventListener('DOMContentLoaded', function () {
  // Subscription button (expects #subscri_btn)
  const subscriptionBtn = document.getElementById('subscri_btn');
  if (subscriptionBtn) {
    subscriptionBtn.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');
      const sellingPlanId = this.getAttribute('data-selling-plan-id');
      const priceEl = this.closest('.price-addtocart')?.querySelector('.withoutdis');
      const price = priceEl?.innerText?.replace(/[^\d.]/g, '');
      console.log(price)
      const properties = {
        'Subscription Plan': 'Subscription',
        'Custom Price': price || ''
      };

      // NOTE: addToCartAndOpenDrawer is fine here;
      // WL quantity enforcement will still happen in drawer open.
      addToCartAndOpenDrawer(variantId, 1, properties, sellingPlanId);
    });
  }

  // One-Time button (expects #onetime_btn)
  const onetimeBtn = document.getElementById('onetime_btn');
  if (onetimeBtn) {
    onetimeBtn.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');
      const priceEl = this.closest('.price-addtocart')?.querySelector('.withoutdis');
      const price = priceEl?.innerText?.replace(/[^\d.]/g, '');
      console.log(price)
      const properties = {
        'Subscription Plan': 'One-Time',
        'Custom Price': price || ''
      };

      checkStockAndAdd(variantId, 1, properties);
    });
  }

  // Header cart icons
  const headerMenu = document.querySelector('.gad_cart_icon_header');
  if (headerMenu) {
    headerMenu.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => openCartDrawer(cart))
        .catch(err => console.error('Error loading cart:', err));
    });
  }

  const gad_cart_desktop = document.querySelector('.gad_cart_desktop');
  if (gad_cart_desktop) {
    gad_cart_desktop.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => openCartDrawer(cart))
        .catch(err => console.error('Error loading cart:', err));
    });
  }

  // Overlay click to close
  const overlay = document.querySelector('.cart-drawer__overlay');
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  // ESC to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCartDrawer();
  });
});
